import p1 from '../../../../assets/posts/p1.png';
import instagram from '../../../../assets/socialIcons/instagram.png';
import facebook from '../../../../assets/socialIcons/facebook.png';
import pintrest from '../../../../assets/socialIcons/pintrest.png';
import linkedin from '../../../../assets/socialIcons/linkedin.png';
import moment from 'moment/moment';

const Post = ({ data }) => {
  const { Createdat, Scheduleat, Status } = data;
  const fallBackImg =
    'https://fastly.picsum.photos/id/1064/400/200.jpg?hmac=SkowchaEel5ElqiB4HKldP-XrMPFz0MfzF4jcNrppIs';
  return (
    <div className="border mt-1">
      <div className="w-[155px]">
        <img
          className="object-cover w-[155px] h-[95px]"
          src={data?.Image?.length ? data?.Image : fallBackImg}
          alt="Post Image"
        />
        <div className="px-2 py-3 space-y-4 bg-white">
          <p className="text-[10px] leading-none truncate">{data?.Content}</p>

          <div className="flex justify-between">
            <div className="flex space-x-1">
              <img className="w-4 h-4" src={instagram} alt="instagram icon" />
              <img className="w-4 h-4" src={facebook} alt="facebook icon" />
              <img className="w-4 h-4" src={pintrest} alt="pintrest icon" />
              <img className="w-4 h-4" src={linkedin} alt="linkedin icon" />
            </div>
            <i className="fa-solid fa-ellipsis-vertical"></i>
          </div>
        </div>
      </div>
      <div className="flex justify-center text-xs border bg-white">
        {Status === 'Live'
          ? `Published at ${moment(Createdat).format('h:mm A')}`
          : `Scheduled at ${moment(Scheduleat).format('h:mm A')}`}
      </div>
    </div>
  );
};

export default Post;
